import React from "react";
import { graphql } from "gatsby";
import { BoardMemberDetail } from "./BoardMemberDetail";
import {
  KontentComponentSettings,
  KontentLinkedDataStaffMember,
  KontentMultiChoice,
} from "../../../types";
import { formatImages } from "../../../lib/images";
import { getMultiChoice } from "../../../lib/multichoice";

interface Props extends KontentComponentSettings {
  board_member: KontentLinkedDataStaffMember;
  orientation: KontentMultiChoice<"full" | "contained">;
}

const BoardMemberDetailContainer: React.FC<Props> = ({
  board_member,
  orientation,
  component_settings__hide_on_mobile,
  component_settings__anchor_name,
  id,
}) => {
  const formatBoardMembers = () => {
    return board_member?.value?.map((member) => {
      const memberElements = member?.elements;
      const image = formatImages(memberElements?.image?.value[0]?.elements);

      return {
        firstName: memberElements?.first_name?.value,
        lastName: memberElements?.last_name?.value,
        appointedYear: memberElements?.appointed_year?.value,
        title: memberElements?.title?.value,
        biography: memberElements?.long_rte__long_text,
        image: image.largeImage,
      };
    });
  };

  const boardMember = formatBoardMembers()[0];

  return (
    <BoardMemberDetail
      id={id}
      boardMember={boardMember}
      orientation={getMultiChoice(orientation)}
      anchor={component_settings__anchor_name.value}
      hideOnMobile={
        getMultiChoice(component_settings__hide_on_mobile) === "yes"
      }
    ></BoardMemberDetail>
  );
};

export default BoardMemberDetailContainer;

export const fragmentBoardMemberDetail = graphql`
  fragment BoardMemberDetail on kontent_item_component___board_member_detail {
    elements {
      board_member {
        ...kontentStaffMember
      }
      component_settings__anchor_name {
        value
      }
      component_settings__hide_on_mobile {
        value {
          codename
        }
      }
      orientation {
        value {
          codename
        }
      }
    }
  }
`;
